import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function NewProjectPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [orgs,  setOrgs]  = useState([]);
  const [techs, setTechs] = useState([]);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    title: '', description: '', status: 'planning',
    org_id: '', lead_tech_id: '',
    estimated_hours: '', budget: '',
    started_at: '', due_date: '',
  });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  useEffect(() => {
    api.get('/orgs').then(d => setOrgs(d.orgs || [])).catch(() => {});
    api.get('/users').then(d => setTechs((d.users || []).filter(u => ['admin','tech'].includes(u.role)))).catch(() => {});
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.title.trim()) return toast.error('Title is required');
    setSaving(true);
    try {
      const { project } = await api.post('/projects', {
        ...form,
        estimated_hours: form.estimated_hours ? parseFloat(form.estimated_hours) : null,
        budget:          form.budget          ? parseFloat(form.budget)          : null,
        org_id:          form.org_id          || null,
        lead_tech_id:    form.lead_tech_id    || null,
        started_at:      form.started_at      || null,
        due_date:        form.due_date        || null,
      });
      toast.success('Project created');
      navigate(`/projects/${project.id}`);
    } catch (err) {
      toast.error(err.message || 'Failed to create project');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <div className="page-header"><h2>New Project</h2></div>
      <div className="page-body">
        <form onSubmit={handleSubmit} style={{ maxWidth: 680 }}>
          <div className="card card-lg" style={{ marginBottom: 16 }}>
            <h3 style={{ fontSize: 14, marginBottom: 16 }}>Project Details</h3>
            <div className="form-group">
              <label className="form-label">Title *</label>
              <input className="form-input" placeholder="e.g. Office 365 Migration" value={form.title} onChange={e => set('title', e.target.value)} required autoFocus />
            </div>
            <div className="form-group">
              <label className="form-label">Description</label>
              <textarea className="form-textarea" style={{ minHeight: 100 }} placeholder="What is this project about?" value={form.description} onChange={e => set('description', e.target.value)} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Status</label>
                <select className="form-select" value={form.status} onChange={e => set('status', e.target.value)}>
                  <option value="planning">Planning</option>
                  <option value="in_progress">In Progress</option>
                  <option value="on_hold">On Hold</option>
                  <option value="completed">Completed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Organization</label>
                <select className="form-select" value={form.org_id} onChange={e => set('org_id', e.target.value)}>
                  <option value="">None</option>
                  {orgs.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
                </select>
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Lead Technician</label>
                <select className="form-select" value={form.lead_tech_id} onChange={e => set('lead_tech_id', e.target.value)}>
                  <option value="">Unassigned</option>
                  {techs.map(t => <option key={t.id} value={t.id}>{t.full_name}</option>)}
                </select>
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Estimated Hours</label>
                <input className="form-input" type="number" min="0" step="0.5" placeholder="e.g. 40" value={form.estimated_hours} onChange={e => set('estimated_hours', e.target.value)} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Budget ($)</label>
                <input className="form-input" type="number" min="0" step="0.01" placeholder="e.g. 5000" value={form.budget} onChange={e => set('budget', e.target.value)} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Start Date</label>
                <input className="form-input" type="date" value={form.started_at} onChange={e => set('started_at', e.target.value)} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Due Date</label>
                <input className="form-input" type="date" value={form.due_date} onChange={e => set('due_date', e.target.value)} />
              </div>
            </div>
          </div>
          <div className="flex gap-3" style={{ justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? <><div className="spinner" style={{ width: 14, height: 14, borderWidth: 2 }} /> Creating…</> : 'Create Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
